import { CSSProperties, useState } from 'react';
import { Divider, Drawer, List, ListItem, ListItemText } from "@mui/material";
import { MdHelp, MdList } from 'react-icons/md';
import { MenuOutlined, CheckCircleOutlined } from '@ant-design/icons';
import logoLogin from '../../assets/login.png';
import { useNavigate } from "react-router-dom";

const iconStyle: CSSProperties = {
  color: "orangered",
  marginRight: 10,
  fontSize: 20
};

const Menu = () => {
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  return (
    <div>
      <div style={{
        textAlign: "center",
        width: "100%",
        backgroundColor: "black",
        position: "fixed",
        zIndex: 999,
        height: 65,
        paddingRight: 32
      }}>
        <img alt="rifas-login" height={120} src={logoLogin} />
        <MenuOutlined
          onClick={() => setOpenDrawer(true)}
          style={{ color: "white", float: "left", paddingLeft: 15, paddingTop: 15, fontSize: 30 }}
        />
      </div>
      <Drawer anchor="left" open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <img alt="rifas-login" height={110} style={{ objectFit: "cover" }} src={logoLogin} />
        <List>
          <ListItem
            style={{
              cursor: "pointer"
            }}
            key={"/"}
            onClick={() => {
              navigate("/");
              setOpenDrawer(false);
            }}
          >
            <MdList style={iconStyle} />
            <ListItemText primary="Lista" />
          </ListItem>
          <Divider />
          <ListItem
            style={{
              cursor: "pointer"
            }}
            key={"/preguntas"}
            onClick={() => {
              navigate("/preguntas");
              setOpenDrawer(false);
            }}
          >
            <MdHelp style={iconStyle} />
            <ListItemText primary="Preguntas" />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};

export default Menu;